// Instala crypto-js usando npm o yarn antes de usarlo
import CryptoJS from 'crypto-js';

// Define una función para descifrar los datos
function decryptData(encryptedData) {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, process.env.VUE_APP_KEYAES);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } catch (error) {
    console.log("tenemos los errores ", error)
  }

}


function encryptData(data) {
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.VUE_APP_KEYAES).toString();
    return encryptedData;
}
export { decryptData, encryptData };